export default function getRefs() {
    return {
        searchForm: document.querySelector('.search-form'),
        galleryBox: document.querySelector('.gallery-box'),
    };
}